import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Button } from '@sololearnorg/sol';

import { Container } from '../../../../../symphony';
import { ActionType, RequestType } from '../../../global-interface';
import { SlLEContext } from '../../../global-constants';
import { SlActions } from '../../../services/ActionsService/sl-actions';
import { ILPTestimonialsData, IFeedbackItem } from '../../../../../api/private/learn-engine-api/landing-page-api.interface';

import s from './TestimonialsSection.scss';

interface ITestimonialsSectionProps {
	data: ILPTestimonialsData;
}

export function TestimonialsSection({
	data,
}: ITestimonialsSectionProps): JSX.Element {
	useStyles(s);
	const { actionBtnText, feedbacks, title } = data;

	const startLearing = () => {
		const { actions$ } = Container.take(SlLEContext, SlActions);

		actions$.next({
			type: ActionType.OnLandingPageCTAClick,
			requestType: RequestType.Parallel,
		});
	};

	return (
		<section className="lp-testimonials-section">
			<div className="lp-testimonials-section__container">
				<h3 className="lp-testimonials-section__title">{title}</h3>
				<div className="lp-testimonials-section__feedback-box">
					{feedbacks.map(
						({ id, feedback, author }: IFeedbackItem) => (
							<article
								className="lp-testimonials-section__feedback-item"
								key={id}
							>
								<div className="lp-testimonials-section__text">
									{feedback}
								</div>
								<div className="lp-testimonials-section__author">
									{author}
								</div>
							</article>
						),
					)}
				</div>
				<Button
					onClick={startLearing}
					size="m"
					className="lp-testimonials-section__action-btn"
				>
					{actionBtnText}
				</Button>
			</div>
		</section>
	);
}
